<template lang="pug">
  v-navigation-drawer(
    :value="isOpen"
    app
    disable-resize-watcher
    width="100%"
    bottom
    class="drawer-mobile"
    @input="onDrawerInput"
  )
    div(class="drawer-mobile__header")
      v-btn(
        icon
        class="drawer-mobile__close"
        @click="close(false)"
      )
        e-svg-icon(
          name="cross-close-dark"
          size="lg"
        )
      h4(class="drawer-mobile__title") {{ $t(title) }}
    div(class="drawer-mobile__body")
      component(
        :is="component"
        v-bind="componentProps"
        :close-drawer="close"
        :close-modal="close"
        :set-title="setTitle"
        @close="close"
      )
</template>

<script>
import MobileDrawer from '~/modules/mobile-drawer/models/MobileDrawer'
import FormDocumentRename from '~/modules/documents/components/forms/form-document-rename'
import FormDocumentSignatures from '~/modules/documents/components/forms/form-document-signatures'
import MDocumentShare from '~/modules/documents/components/modules/m-document-share'
import FormDocumentsFiltersMobile from '~/modules/documents/components/forms/form-documents-filters-mobile'
import MChangeEmail from '~/modules/profile/components/m-change-email'
import FormOrganizationsUsersAdd from '~/modules/organizations/components/modules/forms/form-organizations-users-add.vue'
import FormOrganizationsUsersEdit from '~/modules/organizations/components/modules/forms/form-organizations-users-edit.vue'

export default {
  name: 'MobileDrawer',
  components: {
    FormDocumentRename,
    FormDocumentSignatures,
    MDocumentShare,
    FormDocumentsFiltersMobile,
    MChangeEmail,
    FormOrganizationsUsersAdd,
    FormOrganizationsUsersEdit
  },
  data() {
    return {
      title: null
    }
  },
  computed: {
    drawer() {
      return MobileDrawer.query().first()
    },
    isOpen() {
      return this._.get(this.drawer, 'isOpen', false)
    },
    params() {
      return this._.get(this.drawer, 'params', '')
    },
    component() {
      return this._.get(this.params, 'component')
    },
    componentProps() {
      return this._.get(this.params, 'componentProps')
    }
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.setTitle(this._.get(this.params, 'title', ''))
      }
    }
  },
  created() {
    if (!this.drawer) {
      MobileDrawer.new()
    }
  },
  methods: {
    close(val) {
      this.drawer.close(val)
    },
    setTitle(title) {
      this.title = title
    },
    onDrawerInput(value) {
      if (!value) {
        this.drawer.close()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.drawer-mobile {
  border-radius: 16px 16px 0 0 !important;
  z-index: map-get($zIndexes, 'modal');
  max-height: 90%;
  height: auto !important;

  &__close {
    width: 24px;
    height: 24px;

    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    z-index: map-get($zIndexes, 'base');
  }

  &__header {
    position: relative;
    padding: 12px 16px;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.08);

    &-btn {
      position: absolute;
      top: 50%;
      right: 15px;
      z-index: map-get($zIndexes, 'base');
      transform: translateY(-50%);

      color: #000;
      font-size: 14px !important;
      font-weight: 300;
      line-height: 24px;
      text-decoration: underline;
    }
  }

  &__body {
    padding: 16px;
  }

  &__title {
    color: $black;
    font-variant-numeric: slashed-zero;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
}
</style>
